import styled from 'styled-components';

export const PointerSpan = styled.span`
  cursor: pointer;
  user-select: none;
  font-weight: 600;
`;
